import React from 'react';
import { TextareaWithVariables } from './VariableInsertion';
import MessageRulesEditor from './MessageRulesEditor';

export default function MessageWithOverrides({ rules = [], onRulesChange, availableLanguages = [], modes = ['voice', 'chat'], overrideMaxLength = 500, ...messageProps }) {
  return <MessageRulesEditor
    label={`${messageProps.label} overrides`}
    value={rules}
    onChange={onRulesChange}
    availableLanguages={availableLanguages}
    modes={modes}
    maxLength={overrideMaxLength}
    systemVariables={messageProps.systemVariables}
    dynamicVariables={messageProps.dynamicVariables}
    onAddDynamicVariable={messageProps.onAddDynamicVariable}
    disabled={messageProps.disabled}
    renderMessage={action => <TextareaWithVariables {...messageProps} headerActions={action} />}
  />;
}
